(function (angular) {
  "use strict";

  angular.module("app").service("AdvertsApi", advertsResource);

  advertsResource.$inject = ["settings", "$resource"];

  function advertsResource(settings, $resource) {
    // Create the resource
    var resource = $resource(
      settings.apiBase + "/adverts/:id",
      {},
      {
        get: {
          method: "GET",
          params: {},
          responseType: "json",
        },
        update: {
          method: "PUT",
          responseType: "json",
          params: {
            id: "@id",
          },
        },
      },
    );

    return resource;
  }
})(angular);
